import { PricingTypeDisplay } from '~/constants';
import { display } from '~/utils/displayValues/common';
import { Project } from '~/types/project';

export default function pricingType(project: Project) {
  return display(PricingTypeDisplay[project?.pricingType] ?? '');
}